import Icons from "../../../../resources/icons/Icons";
import CustomMenu from "../../Menus/CustomMenu/CustomMenu";
import { MenuItemEntity } from "../../../../entities/UIEntities/MenuItem";
import { MENU_ITEMS } from "../../../../enums/Enums";
import Strings from "../../../../resources/Strings";
import classes from "./ParkerAllocationCard.module.css";
import sitesDropdownClasses from "../../Dropdowns/SitesDropdown.module.css";
import { Button } from "@mui/material";
import CustomIcon from "../../CustomIcons/CustomIcon";

const ParkerAllocationCard = (props) => {
  const isFobsSupported = props.site.isFobsSupported;
  const isActivateFobMenuItem = !props?.isActive;

  const activationMenuTitle = () => {
    if (isActivateFobMenuItem && isFobsSupported) {
      return MENU_ITEMS.ACTIVATE_FOB;
    }
    if (!isActivateFobMenuItem && isFobsSupported) {
      return MENU_ITEMS.DEACTIVATE_FOB;
    }
    if (isActivateFobMenuItem && !isFobsSupported) {
      return MENU_ITEMS.ACTIVATE_ALLOCATION;
    }
    if (!isActivateFobMenuItem && !isFobsSupported) {
      return MENU_ITEMS.DEACTIVATE_ALLOCATION;
    }
  };

  const managementMenuItems = [
    new MenuItemEntity(
      MENU_ITEMS.OPEN_ALLOCATION_MANAGEMENT,
      () => props.openAllocationManagement(props.allocation),
      false,
      Icons.TOKEN_ITEM,
      false,
      props
    )
  ];

  // used in allocation - assigned parkers & fobs list
  const handleDelete = () => {
    props.handleDeleteCreatedAllocation(props?.allocation?.uuid);
  }

  return (
    <div className={isActivateFobMenuItem ? [classes.allocationContainer, classes.disable].join(' ') : classes.allocationContainer}>
      <div className={classes.leftAllocation}>
        <CustomIcon 
          className={sitesDropdownClasses.siteIcon}
          iconName={props?.image}
        />
        <div className={classes.textContainer}>
          <span className={classes.name}>{props?.name}</span>
          <span className={classes.fob}>
            {props.fob ? `${Strings.FOB} ${props.fob}` : ""}
          </span>
        </div>
      </div>
      {props.showMenuItems && (
      <div className={classes.rightAllocation}>
        <div>
          <CustomMenu menuItems={managementMenuItems}></CustomMenu>
        </div>
      </div>
      )}
      {props.showDeleteAction && (
      <div className={classes.rightAllocation}>
        <div>
        <Button onClick={handleDelete}>
            <img src={Icons.DELETE_ITEM_4} />
        </Button>
        </div>
      </div>
      )}
    </div>
  );
};

export default ParkerAllocationCard;
